export default "__VITE_ASSET__CsNuuKKR__"